import './policy.css';

import { useState } from 'react';

import Content from './content';
import Header from './header';
import Menu from './menu';
import privacyData from './privacy.json';

const Privacy = () => {
  const [privacyIndex, setPrivacyIndex] = useState<number>(0);

  return (
    <>
      <Header />

      <main className="policy-main">
        <div>
          <Menu />

          <Content
            title="Privacy Policy"
            policiesData={privacyData}
            index={privacyIndex}
            setIndex={setPrivacyIndex}
          />

          <aside
            className="policy-top"
            onClick={() => {
              window.scrollTo(0, 0);
            }}
          >
            TOP
          </aside>
        </div>
      </main>
    </>
  );
};

export default Privacy;
